// extracted by mini-css-extract-plugin
export var divider = "_e2-7";
export var itemsToggle = "_e2-8";
export var mergeModal = "_e2-1";
export var optionCard = "_e2-4";
export var radioGroup = "_e2-6";
export var radioOption = "_e2-0";
export var selected = "_e2-5";
export var shipmentOptions = "_e2-2";
export var tableOptions = "_e2-3";